<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <div class="sayfahead m-0">
      <h1><img src="https://cdn.mudu.pro/Design/yapifen.svg" style="height: 20px"> <small>Sayaç Okuma Entegrasyon
        <sup :class="Kurulum?'text-success':'text-danger'">
          <b>{{ this.$store.getters.SubDomain }}-{{ Bina_id }}</b>
        </sup>
      </small>
      </h1>
      <el-button-group class="float-right">
        <el-button type="primary" class="YeniBtn" size="small"
                   @click="SayfaYukle">
          Yenile
        </el-button>
        <el-button v-if="Kurulum" type="success" class="YeniBtn" size="small"
                   @click="FaturaModal=true">
          {{ FaturaBildir }}
        </el-button>
      </el-button-group>
    </div>

    <div class="TanitimBlok" v-if="Kurulum">
      <!--{{Bina}}-->
      <el-dialog
        v-if="FaturaModal"
        :title="FaturaBildir"
        :visible="FaturaModal"
        center
        width="50%">
        <a @click="FaturaModal=false" class="ModalKapat"><i class="el-icon-close"></i></a>
        <el-form :model="Fatura" @submit.prevent.native="FaturaIsle" :rules="FaturaHata" ref="Form">
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item label="Fatura Tarihi" prop="ftarih">
                <el-date-picker
                  v-model="Fatura.ftarih"
                  type="date"
                  placeholder="Fatura Tarihi"
                  format="dd.MM.yyyy"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Son Ödeme Tarihi" prop="starih">
                <el-date-picker
                  v-model="Fatura.starih"
                  type="date"
                  placeholder="Son Ödeme Tarihi"
                  format="dd.MM.yyyy"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Fatura Tutarı" prop="tutar">
                <el-input
                  placeholder="Fatura Tutarı"
                  v-model="Fatura.tutar">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Sayaçtan Ölçülen Hacim" prop="hacim">
                <el-input
                  placeholder="Sayaçtan Ölçülen Hacim"
                  v-model="Fatura.hacim">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Sayaç Okuma ekibine mesajınız" prop="aciklama">
                <el-input
                  placeholder="Sayaç Okuma ekibine mesajınız"
                  type="textarea"
                  v-model="Fatura.aciklama">
                </el-input>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" size="medium" @click="FaturaIsle()" icon="el-icon-check">
            {{ FaturaBildir }}
          </el-button>
        </div>
      </el-dialog>
    </div>
    <div class="TanitimBlok" v-if="!Kurulum && !lo">
      <br>
      <h4>Yapıfen Sayaç Okuma Entegrasyonu</h4>
      <h5>12 Yıllık tecrübemiz ve 10+ kişilik ekibimiz ile hizmet profesyonel veriyoruz</h5>
      <p>Kalorimetrelerinizi ister uzaktan ister fiziksel olarak anında borçlandırma kolaylığı ile Yapıfen'e okutun.</p>
      <a target="_blank"  class="el-button el-button--small el-button--primary"
         :href="'https://api.whatsapp.com/send?phone=908508403806&text=Merhaba, '+BinaKodu+' Kodlu binamın Sayaç Okuma Entegrasyonunu aktif etmenizi istiyorum.'">
        Whatsapp ile Yapıfen'e Entegre Ol
      </a>
    </div>
    <div v-if="Kurulum">
      <table class="table table-xs">
        <thead>
        <tr>
          <th>Dönem Adı</th>
          <th>Eklenme Tarihi</th>
          <th>Durum</th>
          <th class="text-right">Fatura Tutarı</th>
          <th class="text-right">Hacim</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="d in DonemListe" :class="d.Durum=='Tamamlandı'?'':'table-danger'" @click="DetayGetir(d)">
          <td>{{ d.aciklama }}</td>
          <td>{{ d.tarih }}</td>
          <td>{{ d.Durum }}</td>
          <td class="text-right">{{ d.tutar }}<sup>TL</sup></td>
          <td class="text-right">{{ d.hacim }}<sup>kWh</sup></td>
        </tr>
        </tbody>
      </table>
      <el-dialog
        title="Dönem Detay"
        :visible="Modal"
        v-if="Modal"
        center
        width="90%">

        <a @click="Modal=false" class="ModalKapat"><i class="el-icon-close"></i></a>
        <SayacAskiListesi :Fatura="FaturaDetay" :AltToplam="AltToplam" :FaturaDokum="FaturaDokum"></SayacAskiListesi>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import Yukleniyor from "../../../../Doc/Yukleniyor";
import SayacAskiListesi from "./SayacAskiListesi";

export default {
  components: {SayacAskiListesi, Yukleniyor},
  props: ['Bina_id'],
  data() {
    return {
      FaturaModal: false,
      Modal: false,
      DonemListe: null,
      FaturaDetay: null,
      AltToplam: null,
      FaturaDokum: null,
      lo: false,
      Kurulum: false,
      FaturaBildir: "Fatura Bildir",
      Bina: null,
      Kategoriler: null,
      BinaKodu: this.$store.getters.SubDomain + '-' + this.Bina_id,
      Fatura: {
        tutar: null,
        hacim: null,
        ftarih: null,
        starih: null,
        aciklama: null
      },
      FaturaHata: {
        tutar: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        hacim: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        ftarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        starih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      }
    }
  },
  methods: {
    DetayGetir(Fatura) {
      if (Fatura.Durum == 'Tamamlandı') {
        this.lo = true;
        this.$store.dispatch("Get", {path: '_enerji/dokum/fatura/' + Fatura.id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.FaturaDetay = response.Fatura;
              this.FaturaDokum = response.FaturaDokum;
              this.AltToplam = response.AltToplam;
              this.lo = false;
              this.Modal = true;
            } else {
              this.$message.error(response.Mesaj);
            }
          });
      } else {
        this.$message.error("Dönem henüz onaylanmamıştır");
      }


    },
    FaturaIsle() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {

          this.lo = true;
          this.$store.dispatch("Post", {
            ...this.Fatura,
            path: '_enerji/aidatim/fatura/' + this.BinaKodu
          })
            .then(response => {
              if (response.Durum === 'OK') {
                this.$message.success(response.Mesaj);
                this.lo = false;
                this.FaturaModal = false;
                this.SayfaYukle();
              } else {
                this.$message.error(response.Mesaj);
              }
            });

        }
      })
    },
    SayfaYukle() {
      this.lo = true;
      this.FaturaBildir = "Fatura Bildir";
      this.$store.dispatch("Get", {path: '_enerji/aidatim/bina/' + this.BinaKodu})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Bina = response.Bina;
            if (response.Fatura) this.Fatura = response.Fatura;
            if (response.Fatura) this.FaturaBildir = "Fatura Düzenle";
            this.lo = false;
            this.Kurulum = true;
            if (this.Kurulum) this.DonemGetir();
          } else {
            this.lo = false;
            this.$message.error(response.Mesaj);
          }
        });
    },
    DonemGetir() {
      this.$store.dispatch("Get", {path: '_enerji/dokum/bina/' + this.Bina.id})
        .then(response => {
          if (response.Durum === 'OK') {
            this.DonemListe = response.Liste
            this.lo = false
          } else {
            this.$message.error(response.Mesaj);
          }
        });
    }
  },
  created() {
    this.SayfaYukle();

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Tab/BinaEsayac.vue